import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-group-register-terms',
  templateUrl: './group-register-terms.component.html'
})
export class GroupRegisterTermsComponent { }
